import { render, staticRenderFns } from "./d-reviewer-directory-entry.vue?vue&type=template&id=68d8ecac&scoped=true&"
import script from "./d-reviewer-directory-entry.vue?vue&type=script&lang=js&"
export * from "./d-reviewer-directory-entry.vue?vue&type=script&lang=js&"
import style0 from "./d-reviewer-directory-entry.vue?vue&type=style&index=0&id=68d8ecac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d8ecac",
  null
  
)

export default component.exports